import { render } from "./LayoutHeaderLocalePicker.vue?vue&type=template&id=237de34c&scoped=true"
import script from "./LayoutHeaderLocalePicker.vue?vue&type=script&lang=js"
export * from "./LayoutHeaderLocalePicker.vue?vue&type=script&lang=js"

import "./LayoutHeaderLocalePicker.vue?vue&type=style&index=0&id=237de34c&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237de34c"]])

export default __exports__